/** Client-only catalog UI constants (not from API). */

export interface SortOption {
  value: string;
  label: string;
}

export const sortOptions: SortOption[] = [
  { value: "popular", label: "По популярности" },
  { value: "price-asc", label: "Цена: по возрастанию" },
  { value: "price-desc", label: "Цена: по убыванию" },
  { value: "name", label: "По названию" },
  { value: "stock", label: "По наличию" },
];

import categoryDefaultImage from "@/assets/category-default.webp";
import productDefaultImage from "@/assets/product-default.webp";

// The API returns this exact string as a placeholder image value (see
// api/fixtures/catalog.json), so public/product-default.png must keep existing.
export const FALLBACK_PRODUCT_IMAGE = "/product-default.png";

/**
 * Resolves a product's preview image, swapping the API's placeholder path for a
 * bundled WebP — same picture, 20 KB instead of 160 KB, and it appears on every
 * card that has no image of its own.
 */
export function getProductPreviewSrc(product: { previewImage?: string; image?: string }): string {
  const src = product.previewImage || product.image;
  return !src || src === FALLBACK_PRODUCT_IMAGE ? productDefaultImage : src;
}

export function getCategoryPreviewSrc(category: { image?: string }): string {
  return category.image || categoryDefaultImage;
}
